import { useEffect, useState } from "react";
import { ISavingAgreementData } from "@portal/types/robot/ISavingAgreementData";
import { AppDispatch } from "@portal/redux/store";
import { ISavingCalculations } from "@portal/types/robot/ISavingCalculations";
import {
  SavingCalculationsResponseObject,
  setSavingCalculationsResponse,
} from "@portal/redux/reducers/savingCalculationsReducer";

const useSavingCalculations = (request: ISavingAgreementData, dispatch: AppDispatch) => {
  const [isLoading, setIsLoading] = useState(false);

  async function GetUpdatedCalculation() {
    setIsLoading(true);

    const path = "/api/robot/SavingCalculations/";

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request),
    };
    try {
      setIsLoading(false);
      const data = (await fetch(path, requestOptions).then(response => response.json())) as ISavingCalculations;
      const response = { data, isLoading, error: false } as SavingCalculationsResponseObject;
      dispatch(setSavingCalculationsResponse(response));
    } catch {
      setIsLoading(false);
      const response = { data: {}, isLoading, error: true } as SavingCalculationsResponseObject;
      dispatch(setSavingCalculationsResponse(response));
    }
  }

  useEffect(() => {
    GetUpdatedCalculation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, request]);
};

export default useSavingCalculations;
